import type {
  TourFeedbackSentiment,
  TourFeedbackSource,
} from './__generated__/hub-tour-feedback.zeus';

export const TOUR_FEEDBACK_POSITIVE = 'POSITIVE' satisfies TourFeedbackSentiment;
export const TOUR_FEEDBACK_NEGATIVE = 'NEGATIVE' satisfies TourFeedbackSentiment;
export const TOUR_FEEDBACK_SOURCE_POST_TOUR_MODAL = 'POST_TOUR_MODAL' satisfies TourFeedbackSource;
const TOUR_FEEDBACK_POSITIVE_CONFIRMATION = 'Thanks for the feedback.';
export const TOUR_FEEDBACK_NEGATIVE_CONFIRMATION =
  'Thanks for the feedback, we’ll update your recommendations.';

export type QuickTourFeedbackSentiment =
  | typeof TOUR_FEEDBACK_POSITIVE
  | typeof TOUR_FEEDBACK_NEGATIVE;

export function getTourFeedbackConfirmationMessage(sentiment: QuickTourFeedbackSentiment) {
  if (sentiment === TOUR_FEEDBACK_NEGATIVE) {
    return TOUR_FEEDBACK_NEGATIVE_CONFIRMATION;
  }

  return TOUR_FEEDBACK_POSITIVE_CONFIRMATION;
}

export function isQuickTourFeedbackSentiment(
  sentiment?: TourFeedbackSentiment | null,
): sentiment is QuickTourFeedbackSentiment {
  return sentiment === TOUR_FEEDBACK_POSITIVE || sentiment === TOUR_FEEDBACK_NEGATIVE;
}
